import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Blade } from "../../../components/Blade";
import { z } from "zod";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { GroupedMediaPromosBladeSchema, } from "../../../schemas/blades/GroupedMediaPromo";
import { BladeContent } from "../../../components/BladeContent";
import { AspectRatio } from "../../../components/AspectRatio";
import { Media } from "../../../components/Media";
import { RichText } from "../../../components/RichText";
import { Carousel, CarouselControls, CarouselNext, CarouselPrevious, CarouselProgressBar, CarouselSlide, CarouselSlides, CarouselViewport, } from "../../../components/Carousel";
import { BladeHeaderDefault } from "../../../molecules/BladeHeaderDefault";
export var LandingMediaCarouselLayoutEnum;
(function (LandingMediaCarouselLayoutEnum) {
    LandingMediaCarouselLayoutEnum["arWide"] = "arWide";
    LandingMediaCarouselLayoutEnum["arNative"] = "arNative";
})(LandingMediaCarouselLayoutEnum || (LandingMediaCarouselLayoutEnum = {}));
export const LandingMediaCarouselContractSchema = GroupedMediaPromosBladeSchema.extend({
    type: z.literal("landingMediaCarousel"),
});
export const ThumbnailBorder = styled.div ``;
export const ThumbnailLabel = styled.div ``;
const _LandingMediaCarousel = ({ layout, groups, header, ...otherProps }) => {
    const videoRef = useRef(null);
    const [selectedMedia, setSelectedMedia] = useState(0);
    const onSlideChange = useCallback(({ currentSlide }) => {
        setSelectedMedia(currentSlide);
    }, []);
    const currentMedia = groups[selectedMedia];
    const isVideo = currentMedia.content?.media?.type == "video";
    const videoProps = isVideo ? { autoPlay: true, loop: true, controls: true, ref: videoRef } : null;
    const validLayout = React.useMemo(() => {
        if (Object.values(LandingMediaCarouselLayoutEnum).includes(layout || ""))
            return layout;
        return LandingMediaCarouselLayoutEnum.arWide;
    }, [layout]);
    const getAspectRatio = useCallback(() => {
        if (currentMedia?.content?.media?.dimensions?.width &&
            currentMedia?.content?.media?.dimensions?.height &&
            validLayout === LandingMediaCarouselLayoutEnum.arNative) {
            return currentMedia?.content?.media?.dimensions?.width / currentMedia?.content?.media?.dimensions?.height;
        }
        return 16 / 9;
    }, [currentMedia, validLayout]);
    const [viewportAspectRatio, setViewportAspectRatio] = useState(getAspectRatio());
    useEffect(() => {
        videoRef.current?.load();
    }, [videoRef, selectedMedia]);
    useEffect(() => {
        setViewportAspectRatio(getAspectRatio());
    }, [currentMedia, getAspectRatio]);
    return (React.createElement(Blade, { "data-testid": "landing-media-carousel", ...otherProps },
        React.createElement(BladeContent, { width: "large" },
            React.createElement(BladeHeaderDefault, { className: "carousel-header", ...header }),
            React.createElement(AspectRatio, { className: "media-viewport", ratio: viewportAspectRatio }, currentMedia?.content?.media?.dimensions && (React.createElement(Media, { "data-testid": "current-media", className: "main-media", ...videoProps, media: currentMedia.content.media })))),
        React.createElement(BladeContent, { width: "medium" },
            React.createElement(Carousel, { draggable: true, onSlideChange: onSlideChange, currentSlide: selectedMedia },
                groups.length > 1 && (React.createElement(React.Fragment, null,
                    React.createElement(CarouselViewport, null,
                        React.createElement(CarouselSlides, null, groups.map((group, index) => {
                            return (React.createElement(CarouselSlide, { key: group.label },
                                React.createElement("div", { onClick: () => setSelectedMedia(index) },
                                    React.createElement(ThumbnailBorder, { className: "thumbnail-border" },
                                        React.createElement(AspectRatio, { key: group.label, ratio: 16 / 9 }, group?.thumbnail && React.createElement(Media, { media: group.thumbnail, crop: true }))),
                                    React.createElement(ThumbnailLabel, null, group.label))));
                        }))),
                    React.createElement(CarouselControls, null,
                        React.createElement(CarouselProgressBar, null),
                        React.createElement("div", { className: "trigger-wrapper" },
                            React.createElement(CarouselPrevious, null),
                            React.createElement(CarouselNext, null))))),
                currentMedia.content?.description && (React.createElement("div", null,
                    React.createElement("hr", { className: "separator" }),
                    React.createElement("p", { className: "heading" }, currentMedia.content?.title),
                    currentMedia.content?.description && React.createElement(RichText, { ...currentMedia.content.description })))))));
};
export const LandingMediaCarousel = styled(_LandingMediaCarousel) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=LandingMediaCarousel.js.map